import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { Router } from 'react-router-dom';
import Core from 'components/core';

export const AppView = (props) => (
  <Router history={props.history}>
    <Core />
  </Router>
);

AppView.propTypes = {
  history: PropTypes.object.isRequired
};

export default injectIntl(AppView);
